export default function Activity() {
  return (
    <div>
      <p>Activity</p>
    </div>
  );
}
